/**
 * Analytics event tracking helpers.
 * Safely fires Meta Pixel + Google Analytics + Google Ads conversion events;
 * no-ops if any script hasn't loaded yet (e.g. blocked by an ad blocker).
 *
 * Dedup: aynı event ismi 1 saniye içinde tekrar çağrılırsa yut. Bu, kodda
 * kaza eseri çift çağrı olsa bile Meta/GA tarafında duplike görülmesini önler.
 *
 * Standard events used by Camption:
 *  - ViewContent      : hero CTA → tur kataloğunu görüntüledi
 *  - InitiateCheckout : bir tur tarihi için "Ön Rezervasyon" butonuna bastı
 *  - AddToCart        : rezervasyon formunu doldurup gönderdi
 *  - Contact          : WhatsApp butonuna bastı
 */

const DEDUP_WINDOW_MS = 1000;
const lastFiredAt = {};

// Google Ads conversion IDs — set the label as user creates each conversion in
// the Google Ads panel. Missing labels are safely ignored (no fire).
const GOOGLE_ADS_ID = 'AW-18392701779';
const GOOGLE_ADS_LABELS = {
  ViewContent: 'UDWYCITit-IcENO2qcJE',
  InitiateCheckout: 'mMZbCK-axuIcENO2qcJE',
  AddToCart: 'oAQ8COOMw-IcENO2qcJE',
  Contact: '1-pYCKW2uOIcENO2qcJE',
};

export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined') return;
  const now = Date.now();
  if (lastFiredAt[name] && now - lastFiredAt[name] < DEDUP_WINDOW_MS) return;
  lastFiredAt[name] = now;

  // 1) Meta Pixel
  try {
    if (typeof window.fbq === 'function') window.fbq('track', name, params);
  } catch (_) {}

  // 2) Google Analytics 4 (raw event, GA4 gets it via G-PH10MH8D6G config)
  try {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  } catch (_) {}

  // 3) Google Ads conversion (only if a label is mapped for this event)
  try {
    const label = GOOGLE_ADS_LABELS[name];
    if (label && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: `${GOOGLE_ADS_ID}/${label}`,
        value: params.value || 1.0,
        currency: params.currency || 'TRY',
      });
    }
  } catch (_) {}
};

/**
 * Special-event CTA click: GA4 `event_cta_click` + Meta Pixel `Lead`.
 * `eventName` is the event slug id (e.g. 'likya-49w-rasyo').
 */
export const trackEventCtaClick = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;
  const key = `event_cta_click:${eventName}`;
  const now = Date.now();
  if (lastFiredAt[key] && now - lastFiredAt[key] < DEDUP_WINDOW_MS) return;
  lastFiredAt[key] = now;

  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'event_cta_click', { event_name: eventName, ...params });
    }
  } catch (_) {}

  try {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', { content_name: eventName, content_category: 'special-event', ...params });
    }
  } catch (_) {}
};

export const trackViewContent = (params = {}) => trackEvent('ViewContent', params);
export const trackInitiateCheckout = (params = {}) => trackEvent('InitiateCheckout', params);
export const trackAddToCart = (params = {}) => trackEvent('AddToCart', params);
export const trackContact = (params = {}) => trackEvent('Contact', params);
